import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const wikiNavigation: ModuleNavigation = [
  {
    title: 'Knowledge Wiki',
    items: [
      { path: '/wiki', label: 'Index' },
      { path: '/wiki/ingest', label: 'Ingest Source' },
      { path: '/wiki/lint', label: 'Lint Report' },
    ],
  },
];
